import { render } from "./ActividadesHome.vue?vue&type=template&id=4b82ab66"
import script from "./ActividadesHome.vue?vue&type=script&lang=js"
export * from "./ActividadesHome.vue?vue&type=script&lang=js"

import "./ActividadesHome.vue?vue&type=style&index=0&id=4b82ab66&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__